import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Input } from "@/components/Input";
import { ListInputItemsProps } from "./types";
import { ReactSVG } from "react-svg";

export const ListInputItems = ({ inputs, methods, onRemove, onChange }: ListInputItemsProps) => {
  const { t } = useTranslation("feedback");

  return (
    <div data-testid="list-input-items">
      {inputs?.map((input, idx) => {
        const { label, placeholder, className, id, data_qa, value } = input;

        const classnames = classNames("list-input__item", {
          [`${className}`]: className,
        });

        return (
          <div
            key={id}
            className={classnames}
          >
            <Controller
              control={methods?.control}
              name={id}
              rules={{
                required: {
                  value: true,
                  message: t("required_category"),
                },
                maxLength: {
                  value: 200,
                  message: t("category_name_max_length"),
                },
              }}
              render={() => (
                <>
                  <Input
                    id={idx.toString()}
                    type="text"
                    name={id}
                    label={label}
                    placeholder={placeholder}
                    defaultValue={value}
                    dataQA={data_qa}
                    error={methods?.formState?.errors[id]}
                    errorMessage={methods?.formState?.errors[id]?.message}
                    className={inputs?.length > 1 ? "remove-button" : ""}
                    onChange={(e) => onChange(id, e)}
                  />

                  {inputs?.length > 1 && (
                    <ButtonLib
                      id="list-input-remove-button"
                      variant="error"
                      shape="ghost"
                      ariaLabel="Remove item"
                      data-testid="ListInputRemoveButton"
                      dataQA="ListInputRemoveButton"
                      onClick={() => onRemove(id)}
                      iconLeft={
                        <ReactSVG
                          src={`/svg/icon-remove-circle-outline.svg`}
                          strokeWidth={2}
                        />
                      }
                    />
                  )}
                </>
              )}
            />
          </div>
        );
      })}
    </div>
  );
};
